import React, { useState } from 'react';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    // Bejelentkezési adatok .env fájlból (Create React App használja a REACT_APP_ prefixet)
    const validUsername = process.env.REACT_APP_LOGIN_USERNAME || 'admin';
    const validPassword = process.env.REACT_APP_LOGIN_PASSWORD || 'admin123';

    console.log('Login attempt:', { username, validUsername, validPassword });

    if (username === validUsername && password === validPassword) {
      onLogin(username);
      setError('');
    } else {
      setError('Hibás felhasználónév vagy jelszó');
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <img
          src="/vistaverde_logo_feher1.svg"
          alt="Vista Verde Logo"
          className="login-logo"
        />
        
        <h2 className="login-title">Bejelentkezés</h2>
        
        <form onSubmit={handleSubmit} className="login-form-content">
          <div className="form-group">
            <label htmlFor="username" className="form-label">
              Felhasználónév
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="form-input"
              placeholder="Adja meg a felhasználónevet"
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Jelszó
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-input"
              placeholder="Adja meg a jelszót"
              required
            />
          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          <button type="submit" className="login-button">
            Bejelentkezés
          </button>
        </form>
        
      </div>
    </div>
  );
};

export default Login;
